import { render, staticRenderFns } from "./AccidentStatus.vue?vue&type=template&id=84b2d094&scoped=true"
import script from "./AccidentStatus.vue?vue&type=script&lang=js"
export * from "./AccidentStatus.vue?vue&type=script&lang=js"
import style0 from "./AccidentStatus.vue?vue&type=style&index=0&id=84b2d094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b2d094",
  null
  
)

export default component.exports